(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('ticketsLast', TicketsLast)

    /** @ngInject */
    function TicketsLast($rootScope, HelperService, AuthenticationService, HelpdeskService, PATHS, DATA_EVENTS) {
        function TicketsLastController($scope) {
            const vm = this;

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            init();

            function getTickets() {
                HelperService.startLoading('.last-elements.tickets');

                let userData = AuthenticationService.getUserData();
                vm.isLoading = true;

                HelpdeskService
                    .getAllByParameters({
                        PerPage: 4,
                        Skip: 0,
                        OrderBy: 'RegistrationDate',
                        OrderDescending: true
                    }, userData.Id)
                    .then(success => {
                        vm.tickets = success.Ticket;

                        for (let index = 0; index < vm.tickets.length; index++) {
                            vm.tickets[index].LastResponse = vm.tickets[index].TicketTimeline[vm.tickets[index].TicketTimeline.length - 1];
                        }

                        vm.isLoading = false;
                        HelperService.stopLoading('.last-elements.tickets');
                    }, error => {
                        vm.isLoading = false;
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.last-elements.tickets');
                    })
            }

            function init() {
                vm.isLoading = true;
                vm.tickets = [];

                getTickets();
            }
        }

        return {
            bindToController: true,
            controller: TicketsLastController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/tickets-last/tickets-last.html`,
            scope: {}
        }
    }
}());